var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.4998,
    cy: 46.5,
    r: 46.5,
    fill: "#4987FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.8436 41.7188C60.8436 37.9146 59.3324 34.2662 56.6424 31.5762C53.9524 28.8862 50.304 27.375 46.4998 27.375C42.6956 27.375 39.0473 28.8862 36.3573 31.5762C33.6673 34.2662 32.1561 37.9146 32.1561 41.7188C32.1561 47.6029 36.864 55.272 46.4998 64.4584C56.1357 55.272 60.8436 47.6029 60.8436 41.7188ZM46.4998 68.8125C34.8113 58.1886 28.9686 49.1552 28.9686 41.7188C28.9686 37.0692 30.8156 32.61 34.1034 29.3223C37.3911 26.0345 41.8503 24.1875 46.4998 24.1875C51.1494 24.1875 55.6086 26.0345 58.8963 29.3223C62.1841 32.61 64.0311 37.0692 64.0311 41.7188C64.0311 49.1552 58.1884 58.1886 46.4998 68.8125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4998 46.5C47.7679 46.5 48.984 45.9963 49.8807 45.0996C50.7774 44.2029 51.2811 42.9868 51.2811 41.7188C51.2811 40.4507 50.7774 39.2346 49.8807 38.3379C48.984 37.4412 47.7679 36.9375 46.4998 36.9375C45.2318 36.9375 44.0157 37.4412 43.119 38.3379C42.2223 39.2346 41.7186 40.4507 41.7186 41.7188C41.7186 42.9868 42.2223 44.2029 43.119 45.0996C44.0157 45.9963 45.2318 46.5 46.4998 46.5ZM46.4998 49.6875C44.3864 49.6875 42.3595 48.8479 40.8651 47.3535C39.3707 45.8591 38.5311 43.8322 38.5311 41.7188C38.5311 39.6053 39.3707 37.5784 40.8651 36.084C42.3595 34.5896 44.3864 33.75 46.4998 33.75C48.6133 33.75 50.6402 34.5896 52.1346 36.084C53.629 37.5784 54.4686 39.6053 54.4686 41.7188C54.4686 43.8322 53.629 45.8591 52.1346 47.3535C50.6402 48.8479 48.6133 49.6875 46.4998 49.6875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactLocation);
export default __webpack_public_path__ + "static/media/Contact_Location.02acf3af3e6fc3cbd1f5622096ff89b7.svg";
export { ForwardRef as ReactComponent };